import { memo } from "react";

import GraphNode from "./GraphNode";

const GraphNodeReadOnly = (props) => {
  return <GraphNode {...props} readOnly={true} />;
};

export default memo(GraphNodeReadOnly);
